import ReminderOptionType from '../helpers/ReminderOptionType';

/**
 * Checks if the selected reminder is already present in the list of reminder dropdown options
 */

export default function isSelectedReminderPresent(
    reminderDropdownOptions: ReminderOptionType[],
    selectedReminderTimeInMinutes: number
): boolean {
    let selectedReminderPresent = false;
    for (let i = 0; i < reminderDropdownOptions.length; i++) {
        if (reminderDropdownOptions[i].key == selectedReminderTimeInMinutes) {
            selectedReminderPresent = true;
            break;
        }
    }
    return selectedReminderPresent;
}
